import moment from 'moment'
import { get } from 'lodash'

import { primary_color } from '../../../../Helper/uiHelper'
import { asLogRows, lockerEditHeadline, LOCKER_EDIT_LOG_FIELDS, normalizeLockerEditRow } from './lockerEditLog'

const defaultFields = [
  {
    field_id: 'item_id_label',
    label: 'Locker Name',
  },
  {
    field_id: 'location_id_label',
    label: 'Block Name',
  },
  {
    field_id: 'item_date_time_id_label',
    label: 'Academic Year',
  },
]

const headlineFor = (updatedRows, isPaymentCompleted) => {
  if (isPaymentCompleted) {
    return lockerEditHeadline(updatedRows)
  }
  return ' has generated the payment request'
}

const ShowDifference = ({ data, isPaymentCompleted, updated_data, onExpand, fields }) => {
  const rows = asLogRows(updated_data)
  return (
    <div>
      <div className='permission-table'>
        <div className='mb-2 cursor-pointer' onClick={() => onExpand()}>
          <i class='fa-sharp fa-solid fa-arrow-left  m-3'></i>
          Go Back
        </div>
        <div className={`permission-header`} style={{ color: primary_color }}>
          <div className='d-flex align-items-center'>
            <div style={{ flex: 1 }}>
              <span className='font-weight-bold'>{data?.updated_by}</span>
              {headlineFor(rows, isPaymentCompleted)}
            </div>
            {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
          </div>
        </div>
        <div className='p-4'>
          {rows.map((row, index) => {
            const displayRow = isPaymentCompleted ? normalizeLockerEditRow(row) : row
            return (
              <div key={displayRow?.locker_number || displayRow?.item_id_label || index}>
                <div className='p-4'>
                  {fields?.map((item) => {
                    return (
                      <div className='d-flex mb-2 align-items-center' style={{ width: '100%' }} key={item.field_id}>
                        <div className='font-weight-bold mb-2' style={{ width: '40%' }}>
                          {item?.label}:
                        </div>
                        <div style={{ width: '30%' }}>{get(displayRow, item?.field_id)}</div>
                      </div>
                    )
                  })}
                </div>
                <hr></hr>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const PaymentGenerated = ({ data, onExpand, expandedId, parentPageName, isPaymentCompleted }) => {
  let updated_data = data?.updated_data && JSON.parse(data?.updated_data)
  const rows = asLogRows(updated_data)
  const fields = isPaymentCompleted ? LOCKER_EDIT_LOG_FIELDS : defaultFields

  if (expandedId) {
    return (
      <ShowDifference
        data={data}
        isPaymentCompleted={isPaymentCompleted}
        onExpand={onExpand}
        updated_data={updated_data}
        fields={fields}></ShowDifference>
    )
  }
  return (
    <div className='d-flex align-items-center p-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
      <div>
        <i
          class='fa-solid fa-arrow-up-right-from-square mr-2 cursor-pointer'
          style={{ color: primary_color }}
          onClick={() => {
            onExpand(data?.id)
          }}></i>
      </div>
      <div style={{ flex: 1 }}>
        <span className='font-weight-bold'>{data?.updated_by}</span>
        {headlineFor(rows, isPaymentCompleted)}
      </div>

      {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
    </div>
  )
}

export default PaymentGenerated
